import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import LlmProvidersStore from "./LlmProvidersStore";

const llmProvidersRoute: RouteType[] = [
  {
    name: "LlmProviders",
    path: "/ai/providers",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "LLM Providers",
        enableRefreshButton: true,
        component: () => import("./LlmProviders.Header"),
      },
      body: {
        component: () => import("./LlmProviders.Body"),
        grayBackground: true,
      },
    },
    group: "AI",
    searchAliases: ["ai providers", "models"],
    // Provider management (create/edit/test/remove) is admin-only — it governs
    // shared LLM credentials used app-wide. The API enforces the admin gate on
    // writes; this route is admin-only so the view itself is hidden from
    // non-admins.
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.llmProvidersViewStore as LlmProvidersStore;
      store?.load();
    },
    dialogs: [
      {
        name: "LlmProviderFormDialog",
        title: "LLM Provider",
        submitButtonText: "Save provider",
        component: () => import("./dialogs/LlmProviderForm.Body"),
        cancelButton: true,
        height: 560,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.llmProvidersViewStore as LlmProvidersStore;
          const ok = await store.saveProvider();
          // Throwing keeps the dialog open so the error stays visible in
          // the form's alert; resolving closes it and the error is lost.
          if (!ok) {
            throw new Error(store.formError || "Failed to save provider");
          }
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.llmProvidersViewStore as LlmProvidersStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default llmProvidersRoute;
